module.exports = __webpack_public_path__ + "img/uploading.ccf68734.gif";